<div class="container-fluid">
    <div class="page-header">
        <div class="row align-items-end">
            <div class="col-lg-8">
                <div class="page-header-title">
                    <i class="ik ik-book-open"></i>
                    <div class="d-inline"> 
                        <h5>Notifications</h5>
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="col-lg-4">
                <nav class="breadcrumb-container" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <a href="/"><i class="ik ik-home"></i></a>
                        </li>
                        <li class="breadcrumb-item">
                            <a href="#">Notifictions</a>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
        <div class="row">
          <div class="form-group col-12">
    <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
      </mat-form-field>
      </div>
      <div class="table-responsive">
  <table mat-table class="full-width-table" [dataSource]="dataSource" matSort aria-label="Elements">
    <!-- Id Column -->
    <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
            <td mat-cell *matCellDef="let row">{{row.id}}</td>
          </ng-container>
    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Message</th>
      <td mat-cell *matCellDef="let row">{{row.message}}</td>
    </ng-container>
    <ng-container matColumnDef="readed">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Readed</th>
            <td mat-cell *matCellDef="let row">{{row.readed}}</td>
          </ng-container>
        
    <!-- Name Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
      <td mat-cell *matCellDef="let row"><a href="{{row.action}}">View</a></td>
    </ng-container>
   
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
  <mat-paginator #paginator
      [length]="dataSource.data.length"
      [pageIndex]="0"
      [pageSize]="50"
      [pageSizeOptions]="[25, 50, 100, 250]">
  </mat-paginator>
  </div>
  </div>
